import ReactGA from 'react-ga4'

let gaInitialized = false

export const initGA = () => {
  const trackingId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID
  if (!trackingId) return

  ReactGA.initialize(trackingId)
  gaInitialized = true
}

export const logPageView = () => {
  if (!gaInitialized) return
  // console.log(`Logging pageview for ${window.location.pathname}`)
  ReactGA.set({ page: window.location.pathname })
  ReactGA.send({ hitType: "pageview", page: window.location.pathname })
}

export const logEvent = (category = '', action = '', label = '', value = 0) => {
  if (!gaInitialized) return
  if (category && action) {
    const eventObject = {
      category,
      action
    }

    if (label) {
      eventObject.label = label
    }

    if (value) {
      eventObject.value = value
    }
 
    ReactGA.event(eventObject)
  }
}

export const logException = (description = '', fatal = false) => {
  if (!gaInitialized) return
  if (description) {
    ReactGA.exception({ description, fatal })
  }
}